import React, { PureComponent } from 'react';
import { removeQueryParamAndNavigate } from '../../../../../utils/url';
import { postNewPassword, postSetPassword } from '../../../../authentication/api';
import { actionTypeEnum } from '../../../consts';

const AuthenticationNewPasswordController = (OriginalComponent) =>
	class extends PureComponent {
		state = {
			errors: null,
			isPending: false,
		};

		handleFormSubmit = (values) => {
			this.setState({
				errors: null,
				isPending: true,
			});

			const apiFunction =
				this.props.actionType === actionTypeEnum.NEW_PASSWORD ? postNewPassword : postSetPassword;

			apiFunction(values).then(this.handleLoginSuccess).catch(this.handleLoginError);
		};

		handleLoginSuccess = ({ data }) => {
			removeQueryParamAndNavigate('deeplinkid');
			if (data.action) {
				this.props.authenticationSetActionType(data.action);
			}
		};

		handleLoginError = ({
			response: {
				data: { errors },
			},
		}) => {
			if (errors._.sessionExpired) {
				this.props.authenticationSetActionType(actionTypeEnum.SESSION_EXPIRED);
			}

			if (errors._) {
				this.setState({
					errors: errors._,
					isPending: false,
				});
				return;
			}

			this.props.authenticationSetActionType(actionTypeEnum.SORRY_AN_ERROR_OCCURRED);
		};

		render() {
			return (
				<OriginalComponent
					{...this.props}
					{...this.state}
					handleFormSubmit={this.handleFormSubmit}
				/>
			);
		}
	};

export default AuthenticationNewPasswordController;
